<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> {{ isRechazo ? 'Listado de Rechazos de TRACES' : 'Listado de Traslados de TRACES' }}
            </div>

            <div class="card-body-grid" *ngIf="result">

                <p-table #tableSearch autoLayout="true" [value]="result?.ResultList" [lazy]="true"
                         [lazyLoadOnInit]="false" [rowHover]="true"
                         (onLazyLoad)="onSearchLazy($event)" [paginator]="true" [columns]="cols"
                         [rows]="result?.PageSize" sortOrder="0"
                         [totalRecords]="result?.TotalCount" [loading]="loading"
                         [ngClass]="displayGridHidden(result.ResultList)"
                         styleClass="table table-responsive-sm table-sm" dataKey="CHEDPP">

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}"
                                [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='ProductosEmbalajes'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                <span *ngIf="(col.field!=='Link' && col.field!=='Image' && col.field!=='FechaDecision' && col.field!=='ProductosEmbalajes')">
                                    {{rowData[col.field]}}
                                </span>
                                <span *ngIf="col.field==='FechaDecision'">{{rowData[col.field] | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                <div *ngIf="col.field==='Link'" class="btn-group">
                                    <button (click)="onDetail(rowData)" type="button" ngbTooltip="Consultar" placement="right"
                                            class="btn btn-sm btn-info">
                                        <span class="fa fa-search"></span>
                                    </button>
                                </div>

                                <div style="text-align: center;">
                                    <span *ngIf="col.field==='ProductosEmbalajes'">
                                        <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" [title]="expanded ? 'Ocultar productos y embalajes' : 'Mostrar productos y embalajes'" [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                        </a>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">

                        <tr>
                            <td colspan="10">

                                <div *ngIf="rowData['Productos'].length !== 0">
                                    <p (click)="rowData.viewDetailsProductos = !rowData.viewDetailsProductos" class="title-productos-embalajes">Productos <i [ngClass]="rowData.viewDetailsProductos ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="chevron-productos-embalajes"></i></p>
                                </div>

                                <ng-container *ngTemplateOutlet="extensiontemplateproductos; context: rowData"></ng-container>
                                <ng-template #extensiontemplateproductos>
                                    <tr *ngIf="rowData.viewDetailsProductos" style="display: contents !important;">
                                        <div *ngFor="let producto of rowData['Productos']">
                                            <td class="td-cell" colspan="12">
                                                <div class="taric-code" title="Código TARIC">{{producto.CodigoTaric}}</div>
                                                <div class="description"> - {{producto.Descripcion}}</div>
                                            </td>
                                        </div>
                                    </tr>
                                </ng-template>

                                <div *ngIf="rowData['Embalajes'].length !== 0">
                                    <p (click)="rowData.viewDetailsEmbalajes = !rowData.viewDetailsEmbalajes" class="title-productos-embalajes">Embalajes <i [ngClass]="rowData.viewDetailsEmbalajes ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="chevron-productos-embalajes"></i> </p>
                                </div>

                                <ng-container *ngTemplateOutlet="extensiontemplateembalajes; context: rowData"></ng-container>
                                <ng-template #extensiontemplateembalajes>
                                    <tr *ngIf="rowData.viewDetailsEmbalajes" style="display: contents !important;">
                                        <div *ngFor="let embalaje of rowData['Embalajes']">
                                            <td class="td-cell">
                                                <div class="taric-code" title="Código TARIC">{{embalaje.CodigoTaric}}</div>
                                                <div class="description"> - {{embalaje.Descripcion}}</div>
                                            </td>
                                        </div>
                                    </tr>
                                </ng-template>
                            </td>
                        </tr>

                    </ng-template>

            </p-table>

            <!--<div class="p-2" *ngIf="tableSearch.totalRecords">Se han encontrado {{ tableSearch.totalRecords | number:'1.0-0':'es-ES' }} registros</div>-->
            <div class="empty-grid" *ngIf="result?.ResultList?.length === 0">No se ha encontrado ningún registro</div>
        </div>

        </div>
    </div>
</div>
